import { render, staticRenderFns } from "./mailTerminationWizard.vue?vue&type=template&id=7a614921&scoped=true"
import script from "./mailTerminationWizard.vue?vue&type=script&lang=js"
export * from "./mailTerminationWizard.vue?vue&type=script&lang=js"
import style0 from "./mailTerminationWizard.vue?vue&type=style&index=0&id=7a614921&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a614921",
  null
  
)

export default component.exports